import { render, staticRenderFns } from "./MisPedidos.vue?vue&type=template&id=d2c4c8d8"
import script from "./MisPedidos.vue?vue&type=script&lang=js"
export * from "./MisPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports